import { render, staticRenderFns } from "./DividaAtiva.vue?vue&type=template&id=79bdc586&scoped=true"
import script from "./DividaAtiva.vue?vue&type=script&lang=js"
export * from "./DividaAtiva.vue?vue&type=script&lang=js"
import style0 from "./DividaAtiva.vue?vue&type=style&index=0&id=79bdc586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bdc586",
  null
  
)

export default component.exports